export const STORAGE_KEY_LAST_LOGIN_METHOD = "dxp-last-login-method";

export const STORAGE_KEY_LOGIN_REDIRECT_CART_ID = "dxp-login-redirect-cart-id";

export const STORAGE_KEY_APP_JWT = "dxp-app-jwt";

export const STORAGE_KEY_WAITING_FOR_TOKEN = "waiting-for-dxp-token";

export const AVAILABLE_SOCIAL_AUTH_PROVIDERS = ["google", "apple"] as const;
